import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { withSetPropAction } from "mobx-stores/_extension/with-set-props";
import { Base, IBase } from "mobx-stores/_models/base";
import {
  IAddPaperGoodsIssueItem,
  IUpdatePaperGoodsIssueItem,
  PaperGoodsIssueItem,
} from "./paper-goods-issue-item";

export const PaperGoodsIssue = types
  .compose(
    Base,
    types.model({
      issueDate: types.maybeNull(types.string),
    
      items: types.optional(types.array(PaperGoodsIssueItem), []),
    })
  )
  .actions(withSetPropAction);
export interface IPaperGoodsIssue extends Instance<typeof PaperGoodsIssue> {}
export interface IPaperGoodsIssueProperties
  extends SnapshotIn<typeof PaperGoodsIssue> {}

export interface IAddPaperGoodsIssue
  extends Omit<IPaperGoodsIssueProperties, keyof IBase> {
  items: IAddPaperGoodsIssueItem[];
}
export interface IUpdatePaperGoodsIssue
  extends Omit<IPaperGoodsIssueProperties, "items"> {
  items: IUpdatePaperGoodsIssueItem[];
}
